"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const lodash_1 = require("lodash");
const react_redux_1 = require("react-redux");
const redux_form_1 = require("redux-form");
const index_1 = __importDefault(require("./index"));
// ducks
const app_1 = require("ducks/app");
// selectors
const app_2 = require("selectors/app");
const mapStateToProps = (state) => {
    const formNames = (0, redux_form_1.getFormNames)()(state);
    const dirtyForms = (0, lodash_1.map)(formNames, (f) => (0, redux_form_1.isDirty)(f)(state));
    return {
        saveNeeded: (0, app_2.saveNeeded)(state),
        online: (0, app_2.online)(state),
        feedbackMessage: (0, app_2.feedbackMessage)(state),
        dirtyForms,
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = {
    clearAppFeedbackMessage: app_1.clearAppFeedbackMessage,
    doSave: app_1.doSave,
    cancel: app_1.cancel,
};
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
